exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swap-item--invalid .select-fix[data-v-7695a59c]::after {\n  border-top-color: red;\n}\n.swap-item--invalid .select-fix select[data-v-7695a59c] {\n  border-color: red;\n  color: red;\n}", ""]);

// exports
